module.exports = __webpack_public_path__ + "img/thumb-pgt.23757ae6.jpg";